/*!

=========================================================
*　担当者詳細
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle,
  Table,  Row,  Col,
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import OpenFaxModal from '../FormParts/OpenFaxModal'
import ApprovedInfo from '../ViewParts/ApprovedInfo';

const domain = "";
var tmp = [];

class ClientDetail extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      customer_id: "",
      customer_branch_id: "",
      data: [],
      customer: [],
      customer_branch: [],
      pagetitle: "担当者情報詳細"
    };
    this.search = this.search.bind(this);
  } 

  // 検索
  search() {
    /* ここは開発者が記述 */
    var url = domain + '/api/customer/user/'+this.props.match.params.customer_user_id;
    let params = {}
    Request.get(url,params,res => {
      this.setState({
        data:{
          ...this.state.data,
          values : res.Data,
        },
        customer_id:res.Data["customer.ulid"],
        customer:res.Data.customer,
        customer_branch_id:res.Data["customer_branch.ulid"],
        customer_branch:res.Data.customer_branch
      });
      var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
      var params = {};
      Request.get(url, params, res => {
        let tmp = this.state.data.values;
        tmp.lastupdate_user = res.Data;
        this.setState({data:{values:tmp}});
      });
   });
  }

  // 初期ロード用
  UNSAFE_componentWillMount(){
    //var query = queryString.parse(this.props.location.search);
    /*　ここは開発者が記述　*/
    this.search();
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }
  render() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    console.log(this.state.data.values);
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3" className="float-left">{this.state.pagetitle}</CardTitle>
                  <ButtonWithTooltipWithRole
                    button_id="BTN_M1_07_04060"
                    onclick={() => { this.props.history.push("/customer/update/user/"+this.props.match.params.customer_user_id) }}
                    class="float-right btn-facebook"
                    id="tmp"
                    icon="fas fa-pen"
                    link=""
                    label="編集"
                    message={this.props.match.params.customer_user_id+"を編集"}
                    />                    
                </CardHeader>
                <CardBody>
                <Row>
                  <Col md="11" className="detail">
                  <ApprovedInfo
                  visible={this.state.view}
                  rootData={this.state.data}
                  />    
                  <SystemInfo
                        id_title='担当者ID'
                        id_value={this.state.data.values.customer_user_natural_id}
                        update_timestamp={this.state.data.values.update_timestamp}
                        update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                        update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                        visible={this.state.view} />   
                   
                   <CardTitle tag="h4">管理情報</CardTitle>
                    <Table>
                      <tbody>
                        <tr>
                          <CustomTd label='メモ'
                            name='CUSTOMER_USER__system_memo'
                            copy={false}
                            data={this.state.data.values}
                          />
                        </tr>
                        <tr>
                          <CustomTd label='削除フラグ'
                            name='CUSTOMER_USER__delete_flag'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>
                      </tbody>
                    </Table>

                    <CardTitle tag="h4" className="float-left">基本情報</CardTitle>
                    <Table>
                      <tbody>
                        <tr>
                          {/* <th rowSpan="2">会社情報</th> */}
                          <CustomTd label='会社名'
                            name='CUSTOMER__customer_name'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='会社名（カナ）'
                            name='CUSTOMER__customer_name_kana'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          {/* <th rowSpan="4">支店情報</th> */}
                          <CustomTd label='支店名'
                            name='CUSTOMER_BRANCH__customer_branch_name'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='支店名（カナ）'
                            name='CUSTOMER_BRANCH__customer_branch_name_kana'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='電話番号'
                            name='CUSTOMER_BRANCH__customer_branch_tel'
                            copy={true}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='FAX番号'
                            name='CUSTOMER_BRANCH__customer_branch_fax'
                            value={
                              <OpenFaxModal
                                data={this.state.data.values}
                                onClick={()=>this.props.faxModal.current.setFaxModal({
                                  fax_recipient_name:this.state.data.values.customer_name
                                    +"\n"+this.state.data.values.customer_branch_name
                                    +"\n"+this.state.data.values.customer_user_name+" 御中",
                                  fax_recipient_number:this.state.data.values.customer_branch_fax
                                })}
                              />
                            }
                          />
                        </tr>

                        <tr>
                          {/* <th rowSpan="6">担当者情報</th> */}
                          <CustomTd label='担当者名'
                            name='CUSTOMER_USER__customer_user_name'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                          <CustomTd label='担当者名（カナ）'
                            name='CUSTOMER_USER__customer_user_name_kana'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>
                        <tr>
                          <CustomTd label='担当者部署名'
                            name='CUSTOMER_USER__customer_user_division_name'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>
                        <tr>
                          <CustomTd label='携帯電話番号'
                            name='CUSTOMER_USER__customer_user_tel'
                            copy={true}
                            data={this.state.data.values} />
                        </tr>
                        <tr>
                          <CustomTd label='固定電話番号'
                            name='CUSTOMER_USER__customer_user_tel2'
                            copy={true}
                            data={this.state.data.values} />
                        </tr>  
                        <tr>
                          <CustomTd label='メールアドレス'
                            name='CUSTOMER_USER__customer_user_email'
                            copy={true}
                            data={this.state.data.values} />
                        </tr>                       
                        <tr>
                            <CustomTd label='リマインド送信有無'
                              name='CUSTOMER_USER__customer_user_reminder_send_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        <tr>
                          <CustomTd label='SMSリマインド送信有無'
                            name='CUSTOMER_USER__customer_reminder_sms_flag'
                            copy={false}
                            data={this.state.data.values} />
                        </tr>
                        {this.state.data.values.customer_system_use_flag == "1" && this.state.data.values.c_customer_system_use_flag == "1" ? (
                          <tr>
                            <CustomTd label='PUSH通知送信有無'
                              name='CUSTOMER_USER__notification_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        ):""}

                      </tbody>
                    </Table>

                    <Button onClick={() => { 
                      this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id
                        +'&customer_branch_natural_id='+this.state.data.values.customer_branch_natural_id
                        +'&customer_user_natural_id='+this.state.data.values.customer_user_natural_id
                      )}} className="float-left">一覧に戻る</Button>
                  </Col>

                </Row>
                </CardBody>

              </Card>
            </Col>            
          </Row>
        </div>
      </>
    );
  }
}

export default ClientDetail;
